
    /**
    * 账户开启
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13315 {}
  /**
 * YResult :YResult
 */
export class IResid13315 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  export default (account: any,  data?: IReqid13315): AxiosPromise<IResid13315> => request({
        method: 'POST',
        url: '/admin/account/startUsing/'+account,
        data: data
      })